import { render, staticRenderFns } from "./FiltersModal.vue?vue&type=template&id=1724e488&scoped=true&"
import script from "./FiltersModal.vue?vue&type=script&lang=js&"
export * from "./FiltersModal.vue?vue&type=script&lang=js&"
import style0 from "./FiltersModal.vue?vue&type=style&index=0&id=1724e488&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1724e488",
  null
  
)

export default component.exports